import React from 'react'

export default ({ airline, onClick }) => (
  <button
    onClick={() => onClick(airline)}
    className="w-full bg-white border border-gray-200 rounded-lg p-4 mb-3 hover:border-primary-500 hover:shadow-md transition-all duration-200 text-left group"
  >
    <div className="flex items-center">
      <div className="flex-shrink-0 mr-4 w-20 h-12 flex items-center justify-center">
        {airline.logo && (
          <img
            src={airline.logo}
            alt={airline.name}
            title={airline.name}
            className="max-w-full max-h-full object-contain"
          />
        )}
        {!airline.logo && (
          <div className="w-12 h-12 rounded-full bg-primary-600 flex items-center justify-center text-white font-bold text-lg">
            {airline.code}
          </div>
        )}
      </div>
      <div className="flex-1">
        <p className="text-gray-900 font-medium text-base">{airline.name}</p>
        <p className="text-gray-500 text-sm">{airline.code}</p>
      </div>
      <div className="flex-shrink-0 ml-4">
        <svg
          className="w-5 h-5 text-gray-400 group-hover:text-primary-600 transition-colors"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
    </div>
  </button>
)
